export default [
  {
    head: "Why Us?",
    subhead: "What makes us different?",
    first: "One stop service",
    second:
      "No matter what kind of service you require, One Stop Marketing Solutions was born out of our ambition to be a full-service marketing company that delivers consistent results to our clients, regardless of the type of service our clients require.",
    third: "360 Approach",
    fourth:
      "It's critical for your business and product that you pick the right 360-advertising strategy and planning. Your brand will become more well-known and visible through effective ad placement. Let us help you determine the best option for your marketing plan.",
    fifth: "Years of Experiences",
    sixth:
      "Our expertise in the advertising space has helped brands reach more specific and wider audiences. We know what it takes to make your audience feel connected to a particular brand.",
  },
  {
    head: "Kenapa Kami?",
    subhead: "Apa yang buat kami berbeda?",
    first: "One stop service",
    second:
      "Solusi One Stop Marketing muncul dari keinginan kami untuk menjadi agency pemasaran yang komprehensif dengan memberikan hasil yang memuaskan kepada klien kami, terlepas dari layanan yang dibutuhkan.",
    third: "360 Approach",
    fourth:
      "Merupakan hal yang penting bagi bisnis dan produk Anda untuk mendapat perencanaan dan strategi pemasaran secara 360-derajat. Brand Anda akan lebih dikenal dan terlihat melalui penempatan iklan yang efektif. Mari kami bantu untuk memilih opsi terbaik yang sesuai dengan rencana pemasaran Anda",
    fifth: "Years of Experiences",
    sixth:
      "Keahlian kami dalam bidang periklanan telah membantu brand-brand untuk menjangkau target pasar yang lebih spesifik dan lebih luas. Kami tahu apa yang diperlukan agar target pasar brand Anda menimbulkan rasa keterikatan terhadap brand tertentu.",
  },
];
